module.exports = __webpack_public_path__ + "static/img/head.95de25e5.png";